/**
 * The `bill.*` capabilities (CAPABILITIES.md §3.4): the bill of an order. Ids from the cart
 * contract (P0 step 12); policies in C1, hidden until then.
 */
import { definePolicies } from "../engine";
import type { OrderResource } from "./order";

declare module "../types" {
  interface CapabilityMap {
    /** see the bill as it will print, and print it */
    "bill.view": OrderResource;
    /** add or change the order's charges */
    "bill.charges": OrderResource;
  }
}

export const BILL_POLICIES = definePolicies("bill", []);
